module.exports = __webpack_public_path__ + "static/media/ill_bloodpressure.c2fa3716.svg";